export const meta = () => {
  return [
    {
      title: "Refund Policy | TailoredCV.ai",
    },
    {
      name: "description",
      content:
        "Learn about our refund policy and how to request a refund for your TailoredCV.ai subscription.",
    },
    {
      name: "keywords",
      content: "refund, policy, refund policy, refund policy, refund policy",
    },
    {
      tagName: "link",
      rel: "canonical",
      href: "https://tailoredcv.ai/legal/refund-policy",
    },
  ];
};

# Refund Policy

**Effective Date:** August 1, 2024

## 1. Introduction

Thank you for using TailoredCV.ai, a service provided by Outboard Support Hub LLC ("we," "us," "our," or "Outboard Support Hub"). We strive to provide high-quality services to meet your needs. However, if you are not entirely satisfied with your purchase, we’re here to help.

## 2. Subscription Plans

TailoredCV.ai offers both monthly and annual subscription plans. Please note the following regarding refunds for subscription plans:

- **Monthly Subscriptions:** Monthly subscriptions are billed on a monthly basis and can be canceled at any time. Once canceled, your subscription will remain active until the end of the current billing period, after which it will not renew. We do not offer refunds for any unused portion of the current billing month.

- **Annual Subscriptions:** Annual subscriptions are billed once a year and provide a cost-saving compared to monthly plans. If you cancel an annual subscription, it will remain active until the end of the current annual billing period. We may offer partial refunds for unused portions of annual subscriptions on a case-by-case basis.

## 3. Refund Eligibility

Refunds are typically not provided for monthly subscriptions, except in the following circumstances:

- You experience technical issues with our service that prevent you from using it as intended, and these issues cannot be resolved by our support team.
- The service was not delivered as described or promised, and we are unable to rectify the issue.

To request a refund, please contact our customer support team at [support@tailoredcv.ai](mailto:support@tailoredcv.ai) within 3 days of your purchase, providing details about your request.

## 4. How to Request a Refund

To request a refund, follow these steps:

1. **Contact Us:** Email us at [support@tailoredcv.ai](mailto:support@tailoredcv.ai) with your refund request. Include your account details, the reason for the refund, and any relevant information about the issue you experienced.

2. **Review Process:** We will review your refund request and may contact you for additional information. Please allow up to 5 business days for us to process your request.

3. **Refund Decision:** Once your request has been reviewed, we will notify you of the outcome. If your refund is approved, the funds will be credited to your original payment method within 5 business days.

## 5. Non-Refundable Items

Certain items are non-refundable, including but not limited to:

- Services that have been fully rendered and utilized by you.
- Payments made more than 3 days ago.

## 6. Chargebacks

If you initiate a chargeback through your bank or payment provider, we reserve the right to suspend your account and access to TailoredCV.ai until the matter is resolved. Please contact us directly to resolve any billing issues before initiating a chargeback.

## 7. Changes to This Refund Policy

We may update this Refund Policy frequently. We will notify you of any changes by posting the new Refund Policy on our website and updating the "Effective Date" at the top. You are advised to review this Refund Policy periodically for any changes.

## 8. Contact Us

If you have any questions or concerns about this Refund Policy, please contact us at:

Outboard Support Hub LLC  
Address: 75 East 3rd Street, Sheridan 82801, Wyoming, United States  
Email: contact@tailoredcv.ai

Thank you for using TailoredCV.ai. We appreciate your business and are committed to providing you with the best possible service.

---
